import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { student } from "../../constants/apiUrl";
import { IStudentSubjectGrades } from "../../models/student/studentGrades";

export default new (class StudentSubjectGradesService {
  public getSubjectGrades = async (
    semesterId: number,
    studentId:string
  ): Promise<IApiResponse<IStudentSubjectGrades>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_GRADE,[`${semesterId}/${studentId}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentSubjectGrades>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentSubjectGrades>;
      } else {
        throw error;
      }
    }
  };
});